import { ColumnMetadata } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { Emdash } from "~/components/Punctuation";

export const CUSIP_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    slug: AssetColumns.cusip,
    sortsOn: AssetColumns.cusip,
    label: "CUSIP",
    type: "string",
    tooltip:
        "A CUSIP number is a unique nine-digit identification number assigned to financial securities in the United States and Canada.",
    width: 100,
    render: (item) => {
        if (item.isAsset) {
            if (!item.cusip) {
                return <Emdash />;
            }

            return <span className="font-mono">{item.cusip}</span>;
        }

        return <Emdash />;
    },
};
